import React, { useContext, useState } from 'react'
import { Button, makeStyles } from '@material-ui/core'
import Add from '@material-ui/icons/Add'
import { useHistory } from 'react-router-dom'
import { Context as PortfolioContext } from '../contexts/portfolio'
import addFolder from '../assets/images/addFolder.svg'
import emptyData from '../assets/images/emptydata.svg'
import FilterPortfolioTableMobile from './FilterPortfolioTableMobile'
import Loading from './Loading'
import RemovePortfolioDialog from './ConfirmRemotePortfolio'

const useStyles = makeStyles({
  table: {
    '& .MuiTableHead-root': {
      '& .MuiTableCell-head': {
        padding: '24px 0px 12px 0px',
        borderBottom: 'none',
        '& span': {
          color: '#475569',
          fontSize: 12,
          lineHeight: '18px',
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiTableSortLabel-icon': {
          display: 'none',
        },
      },
    },
    '& .MuiTableBody-root': {
      '& tr:hover': {
        boxSizing: 'border-box',
        boxShadow: '1px 1px 5px rgb(0 0 0 / 20%)',
        '& th': {
          color: '#2160BA',
        },
      },
      '& svg': {
        opacity: 0,
      },
      '& :hover': {
        backgroundColor: 'transparent',
        '& svg': {
          opacity: 1,
          color: '#DE3131',
        },
      },
      '& .MuiTableCell-body': {
        paddingTop: 13,
        paddingBottom: 13,
        color: '#1B3963',
        fontSize: 12,
        borderBottom: 'none',
        '&:nth-child(2)': {
          fontWeight: 600,
        },
      },
    },
  },
  tableRow: {
    cursor: 'pointer',
    '&:nth-child(odd)': {
      backgroundColor: '#F8FAFC',
    },
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 16px',
    border: '1px solid #DFE4EB',
    marginTop: '20px',
    borderRadius: 5,
  },
  riskStatus: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 8,
  },
  nowStatus: {
    borderRadius: '50%',
    width: 12,
    height: 12,
    position: 'relative',
    marginLeft: 5,
    '& > div': {
      background: '#fff',
      opacity: 0.65,
      borderRadius: '50%',
      width: 6,
      height: 6,
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  prevStatus: {
    borderRadius: '50%',
    width: 8,
    height: 8,
  },
  companyCount: {
    marginBottom: 30,
  },
  count: {
    color: '#1B3963',
    fontSize: 28,
    lineHeight: '36px',
  },
  titleCount: {
    color: '#1B3963',
    fontSize: 14,
    lineHeight: '22px',
  },
  moreIcon: {
    color: '#1B3963',
    opacity: 0.35,
  },
  tableContainer: {
    maxHeight: 650,
    overflow: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  sortIcon: {
    width: 15,
  },
  emptyPortfolio: {
    minHeight: 540,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '& img': {
      width: 135,
    },
    '& h4': {
      fontWeight: 600,
      color: '#5E5E5E',
      fontSize: 20,
      marginTop: 30,
    },
    '& p': {
      color: '#474747',
      fontWeight: 400,
      textAlign: 'center',
      marginTop: 20,
      lineHeight: '30px',
      maxWidth: 322,
      fontSize: 14,
    },
  },
  button: {
    width: 'auto',
    height: '40px',
    color: '#fff',
    backgroundColor: '#1B3963',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    fontSize: 14,
    marginTop: 20,
    padding: '7px 12px',
    '&:hover': {
      backgroundColor: '#1B3963',
    },
  },
  companyNameColumn: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#1B3963',
  },
  regularColumnValue: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
  },
  SpinnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: 40,
    },
  },
  mItemRow: {
    background: '#F4F5F7',
    borderRadius: 3,
    boxSizing: 'border-box',
    padding: '10px 12px',
    marginBottom: 12,
  },
  mItemHead: {},
  mItemHeadTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 500,
    color: '#1B3963',
  },
  mItemHeadTrashIcon: {},
  mItemContent: {},
  mItemContentItem: {},
  mItemContentItemSub: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  mItemContentItemSubLeft: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  mItemContentItemSubRight: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  mItemHeadRow1: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mItemHeadRow2: {
    paddingBottom: 12,
    marginBottom: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: '1px solid #DFE4EB',
  },
  mItemHeadCircleCombo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 12,
  },
  mItemHeadCircleBig: {
    width: 12,
    height: 12,
    borderRadius: '100%',
    boxSizing: 'border-box',
    background: 'rgba(255, 131, 78, 0.2)',
    border: '3px solid #FF834E',
    marginRight: 4,
  },
  mItemHeadCircleSmall: {
    width: 8,
    height: 8,
    background: '#FFC42C',
    borderRadius: '100%',
  },
  mItemHeadCircleTitle: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#1B3963',
  },
  mItemContentItemTitle: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 4,
  },
  mItemContentItemValue: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#1B3963',
  },
  portfolioTableTitle: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#181818',
    marginBottom: 16,
  },
  emptyPortfolioText: {
    fontSize: '0.7rem',
  },
  arrowRiskChange: {
    opacity: '1 !important',
    paddingLeft: '5px',
  },
  showStatusHeader: {
    color: '#1B3963',
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'none',
    '& img': {
      color: '#474747',
    },
  },
  status: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    '& div': {
      fontWeight: 600,
      marginRight: 10,
    },
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    position: 'relative',
    '& > div': {
      height: 16,
      width: 16,
      opacity: '0.35',
      borderRadius: '50%',
      position: 'absolute',
      left: '-4px',
      top: '-4px',
      margin: 0,
      'animation-name': `$backgroundColorPalette`,
      'animation-duration': '1s',
      'animation-iteration-count': 'infinite',
      'animation-direction': 'alternate',
      'animation-timing-function': 'liner',
    },
  },
  tableScrollable: {
    maxHeight: 430,
    overflowY: 'auto',
    paddingRight: 8,
    paddingTop: 5,
  },
})

export const INIT_FILTER = {
  sector: [],
  industry: [],
  region: [],
  country: [],
  searchByWord: '',
}

interface PortfolioTableMobileProps {
  tickers: any[]
  selectedFilter: typeof INIT_FILTER
  setSelectedFilter: (params: typeof INIT_FILTER) => void
  onResetAll: () => void
  tickerId: string
  activeNode: string
}

type Order = 'asc' | 'desc'

const PortfolioTableMobile = ({
  tickers,
  selectedFilter,
  setSelectedFilter,
  onResetAll,
  tickerId,
  activeNode,
}: PortfolioTableMobileProps) => {
  const classes = useStyles()
  const { state } = useContext(PortfolioContext)
  const history = useHistory()
  const [openConfirmRemoveDialog, setOpenConfirmRemoveDialog] = useState(false)
  const [removeData, setRemoveData] = useState(null)

  const handleCompanyClick = React.useCallback(
    (tickerId: string) => {
      window.scrollTo(0, 0)
      history.push(`/company/${tickerId}`)
    },
    [history],
  )

  return (
    <>
      {!tickers.length && !selectedFilter?.searchByWord ? (
        <div className={classes.portfolioTable}>
          <div className={classes.emptyPortfolio}>
            <img alt="" src={addFolder} />
            <h4>No recently added portfolio</h4>
            <p>
              Your portfolio is empty. Please search and select a company to
              add.
            </p>
            <Button startIcon={<Add />} className={classes.button}>
              Add your first portfolio
            </Button>
          </div>
        </div>
      ) : (
        <>
          <div className={classes.portfolioTable}>
            <FilterPortfolioTableMobile
              tickers={tickers}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              onResetAll={onResetAll}
              activeNode={state.activeNode}
            />
            {!tickers.length && selectedFilter?.searchByWord ? (
              <div className={classes.portfolioTable}>
                <div className={classes.emptyPortfolio}>
                  <img alt="" src={emptyData} />
                </div>
              </div>
            ) : (
              <div className={classes.table} aria-label="simple table">
                <div className={classes.tableScrollable}>
                  {tickers.map((row, i) => (
                    <div
                      className={classes.mItemRow}
                      onClick={() => handleCompanyClick(row.ticker)}
                    >
                      <div className={classes.mItemHead}>
                        <div className={classes.mItemHeadRow1}>
                          <div className={classes.mItemHeadTitle}>
                            {row.proper_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
      <RemovePortfolioDialog
        open={openConfirmRemoveDialog}
        setOpen={setOpenConfirmRemoveDialog}
        removeData={removeData}
        setRemoveData={setRemoveData}
      />
    </>
  )
}

export default PortfolioTableMobile
